import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TrainingParticipantLayer from "../components/TrainingParticipantLayer";

const TrainingParticipantPage = () => {
    return (
        <MasterLayout>
            <TrainingParticipantLayer />
        </MasterLayout>
    );
};

export default TrainingParticipantPage;
